/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { shift_requests_ShiftRequestGroup } from './shift_requests_ShiftRequestGroup';
export type shift_requests_ShiftRequestResponse = {
    /**
     * True when the caller may approve or reject the request.
     */
    can_decide: boolean;
    /**
     * swap: the named colleague, or the colleague who accepted.
     */
    counterpart_employee_id?: string;
    counterpart_name?: string;
    created_at: string;
    decided_at?: string;
    end_time: string;
    groups: Array<shift_requests_ShiftRequestGroup>;
    id: string;
    /**
     * claim or swap
     */
    kind: shift_requests_ShiftRequestResponse.kind;
    note?: string;
    /**
     * taken (another claim won) or changed (the planner changed the shift) for a superseded
     * request; the decider's free text for a rejected one.
     */
    reason?: string;
    /**
     * claim: the claimant; swap: the holder who offers the shift.
     */
    requester_employee_id: string;
    requester_name: string;
    shift_date: string;
    shift_id: string;
    shift_status: string;
    start_time: string;
    /**
     * pending, accepted, approved, rejected, withdrawn or superseded
     */
    status: shift_requests_ShiftRequestResponse.status;
    /**
     * The open shift_request workflow item, when there is one.
     */
    workflow_item_id?: string;
};
export namespace shift_requests_ShiftRequestResponse {
    /**
     * claim or swap
     */
    export enum kind {
        CLAIM = 'claim',
        SWAP = 'swap',
    }
    /**
     * pending, accepted, approved, rejected, withdrawn or superseded
     */
    export enum status {
        PENDING = 'pending',
        ACCEPTED = 'accepted',
        APPROVED = 'approved',
        REJECTED = 'rejected',
        WITHDRAWN = 'withdrawn',
        SUPERSEDED = 'superseded',
    }
}

